import React from "react";
import R from "ramda";
import styled from "styled-components";

import {
	gql,
	graphql,
} from "react-apollo";

import Button from "./button";

//------------------------------

const Sidebar = styled.div`
	align-items: center;
	background-color: ${ ({ theme, }) => ( theme.colors.main ) };
	box-shadow: 0px 0px 8px black;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	overflow: hidden;
`;

const getAllOrgs = gql`
	query GetAllOrgs{
		viewer {
			user {
				id
				personal {
					id
				}
				memberOf {
					edges {
						node {
							id
						}
					}
				}
				adminOf {
					edges {
						node {
							id
						}
					}
				}
			}
		}
	}
`;

//------------------------------

export default graphql(
	getAllOrgs,
	{
		name: "getAllOrgs",
	}

)(

	(props) => {
		const orgIDs = R.pipe(
			R.path([ "getAllOrgs", "viewer", "user", ]),

			R.evolve({
				memberOf: R.propOr([], "edges"),
				adminOf: R.propOr([], "edges"),
			}),

			R.pick([
				"memberOf",
				"adminOf",
			]),

			R.values,

			R.flatten,

			R.map( R.path([ "node", "id", ]) ),

			R.filter(R.identity),
			R.uniqBy(R.identity),
		)(props);

		return (
			<Sidebar>
				<Button
					isUser
					differentiateUserAndOrg = { props.differentiateUserAndOrg } 
				/>
				{ 
					(props.getAllOrgs.loading)
					? R.times(R.identity, 3).map( (i) => (
						<Button isPlaceholder key = { i }/>
					))
					: orgIDs.map((orgID) => (
						<Button
							isOrg
							key = { orgID }
							id = { orgID }
							differentiateUserAndOrg = { props.differentiateUserAndOrg } 
						/>
					))
				}

				<Button isAddNew />
			</Sidebar>
		);
	}
);
